export const SORT_BY_PRICE_CHEAPEST = 'price_asc';
export const SORT_BY_PRICE_HIGHEST = 'price_desc';
export const SORT_BY_FILTER_KEY = 'sortBy';
